import React, { useEffect } from 'react';

const VocalNetTutorial = () => {
  useEffect(() => {
    window.location.href = 'https://delicate-freezer-d29.notion.site/Getting-Started-with-VocalNet-13f57c170c46805aaee1cdcea3a2c28c';
  }, []);

  return null; // No UI is rendered
};

export default VocalNetTutorial;
